import { createFileRoute } from "@tanstack/react-router";
import Landing from "@/pages/Landing";

/**
 * The landing page at a path, so it can be looked at without the domain.
 *
 * The root domain is the only place this page is published, and neither a
 * developer's machine nor the Lovable preview answers on that name. This route
 * draws exactly what `syncani.com` draws, on whatever host is asking.
 *
 * It is kept out of the index: the same words on two addresses is one page
 * competing with itself, and the address that should win is the domain.
 */
export const Route = createFileRoute("/landing")({
  head: () => ({ meta: [{ name: "robots", content: "noindex" }] }),
  component: Landing,
});
